import moment from "moment";
import { state as stateApp } from "../../../../app.logic";

export const formatInputValue = (str, format) => {
    let value = moment(str, format, true);
    if (!value.isValid()) {
        return str;
    }
    let yyyy = value.format("YYYY");
    if (stateApp.locale === "th") {
        yyyy = parseInt(value.format("YYYY")) + 543;
    }
    return value.format(format.replace("YYYY", yyyy).replace("YY", yyyy.toString().substring(2, 4)));
};

export const formatToMask = (format) => {
    return format.replace(/[A-Za-z]/g, "#");
};

export const formatToPlaceholder = (format) => {
    return format.toUpperCase();
};

export const onUpdateInputValue = ({ data, format, valueFormat, emit }) => {
    return (inputValue) => {
        data.inputValue = inputValue;
        let value = moment(data.inputValue, format, true);
        if (value.isValid()) {
            if (stateApp.locale === "th") {
                value = value.subtract(543, "years");
            }
            data.inputValue = value.format(format);
            emit("update:value", value.format(valueFormat));
        }
    };
};

export const onBlurInputValue = ({ data, format, valueFormat, emit }) => {
    return () => {
        const value = moment(data.inputValue, format, true);
        if (value.isValid()) {
            emit("update:value", value.format(valueFormat));
        } else {
            emit("update:value", null);
        }
    };
};

export const onUpdateValue = ({ emit }) => {
    return (value) => {
        emit("update:value", value);
    };
};

export const createOnChange = ({ props, data }) => {
    return () => {
        if (!props.showTime) {
            data.open = false;
        }
    };
};

export const createOnOpenChange = ({ data }) => {
    return (open) => {
        data.mode = "date";
        data.open = open;
    };
};

export const createOnPanelChange = ({ data }) => {
    return (value, mode) => {
        data.mode = mode;
    };
};
